import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import Breadcrumb from "../../../components/Breadcrumb";
import LibraryCurriculum from "../../../components/Content/libraryCurriculum";
import Loading from "../../../components/Loading";
import ProtectedRoute from "../../../components/ProtectedRoute";
import URL from "../../../config/api";
import axios from "../../../config/axios";

class LibraryCurriculumPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      type: 0,
      types: []
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.initContent();
  }

  initContent() {
    this.setState({ loading: true });
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    axios
      .get(`${URL.api}content/type/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        let responseData = resp.data.data;
        this.setState({ types: responseData, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  render() {
    return (
      <>
        <Breadcrumb current={this.props.currentRoute} />
        {this.state.loading ? (
          <div className="p-4">
            <Loading />
          </div>
        ) : (
          <LibraryCurriculum
            currentRoute={this.props.currentRoute}
            types={this.state.types}
          />
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ logout, setObj }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LibraryCurriculumPage);
